import React from 'react';
import EliasBackButton from '../../../atoms/EliasBackButton/EliasBackButton';
import ROUTER_URLS from '../../../utils/router/urls';
import ResultsLoading from '../../../compounds/ResultsLoading/ResultsLoading';
import Dashboard from '../../../compounds/Dashboard/Dashboard';
import PlayerSpanFilters from '../../../compounds/PlayerSpanFilters/PlayerSpanFilters';
import EliasStatsFilter from '../../../compounds/EliasStatsFilter/EliasStatsFilter';
import PlayerSpanTable from '../../../compounds/PlayerSpanTable/PlayerSpanTable';
import { fetchNcaaPlayerSpanStats } from '../../../../api/ncaawbb';
import { statsFilters, spanRangeOptions, PAGE_TITLE, PAGE_SUBTITLE } from './constants';
import API_URLS from '../../../../api/api_urls';
import ModalFilters from '../../../compounds/ModalFilters/ModalFilters';
import { advancedModalFilterCategories } from '../constants';
import { ContextFilterType } from '../../../types/context';
import NcaaWbbPlayerFiltersLayout from '../../../compounds/ncaawbb/NcaaWbbPlayerFiltersLayout';
import FinderStackLayout from '../../../compounds/FinderStackLayout/FinderStackLayout';
import withResultsLayout, { WithResultsLayoutProps } from '../../../compounds/ResultsWrapper/ResultsWrapper';
import { mapRows } from '../../../utils/ncaawbb/span-finder/map-results';
import { mapColumns } from '../../../utils/ncaawbb/span-finder/map-columns';
import { appendContextFilters } from '../../../utils/ncaawbb/search';
import Header from '../../../compounds/Common/Header';
import EXTERNAL_URLS from '../../../utils/router/external_urls';
import NcaaWbbDataInfoModal from '../../../compounds/ncaawbb/NcaaWbbDataInfoModal';
import { FINDER_TYPES } from '../../../utils/common/constants';

const LOADING_MESSAGE = 'Spans are data intensive and may take longer than other finders to produce results.';

interface IProps extends WithResultsLayoutProps {};

function PlayerSpanFinderResults({
  columnHeaders,
  resultsData,
  tableDataLoading,
  filtersLoading,
  error,
  handleDone,
  pageOrSortDataFetch
}: IProps) {

  const pageSpecificSearchEnabled = (context: ContextFilterType): boolean =>
    Boolean(context.spanLength) && Number(context.spanLength) > 1;

  const statsFilterPartial = <EliasStatsFilter statsFilterOptions={statsFilters} displayYearInfo={false} />;
  const bottomModalPartial = (
    <ModalFilters
      buttonTitle='Advanced Filters'
      filters={advancedModalFilterCategories}
      filterType='advancedFilters'
      finderType={FINDER_TYPES.PLAYER_SPAN}
    />
  );

  return (
    <Dashboard loading={filtersLoading}>
      <FinderStackLayout
        header={
          <Header
            title={PAGE_TITLE}
            subtitle={PAGE_SUBTITLE}
            backButton={
              <EliasBackButton route={ROUTER_URLS.ncaawbb.playerSpanFinderSearch} />
            }
          />
        }
        topPanel={
          <NcaaWbbPlayerFiltersLayout
            handleDone={handleDone}
            statsFilterPartial={statsFilterPartial}
            pageSpecificSearchEnabled={pageSpecificSearchEnabled}
            apiUrls={API_URLS.ncaawbb}
            bottomModalPartial={bottomModalPartial}
          >
            <PlayerSpanFilters spanRangeOptions={spanRangeOptions} />
          </NcaaWbbPlayerFiltersLayout>
        }
        bottomPanel={
          tableDataLoading || error ?
          <ResultsLoading error={error} loadingMessage={LOADING_MESSAGE} /> :
          <PlayerSpanTable
            data={resultsData?.results ?? []}
            dataCount={resultsData?.count ?? 0}
            dataMetaInfo={resultsData?.query?.back_to ?? []}
            columnData={columnHeaders || []}
            handleDone={pageOrSortDataFetch}
            linkUrls={EXTERNAL_URLS.NCAAW}
            explanationMessage={ <NcaaWbbDataInfoModal /> }
          />
        }
      />
    </Dashboard>
  );
}

export default withResultsLayout(
  PlayerSpanFinderResults,
  ROUTER_URLS.ncaawbb.playerSpanFinderResults,
  statsFilters,
  fetchNcaaPlayerSpanStats,
  mapColumns,
  mapRows,
  appendContextFilters,
  true, // translateNcaawFilters
  FINDER_TYPES.PLAYER_SPAN,
  advancedModalFilterCategories,
);
